import React from 'react';
import PropTypes from 'prop-types';
import { QuickNavigation } from '../components';
import { localStore } from 'helpers';
import consts from 'consts';

const QuickNavigationContainer = props => {
  const { LOGIN_TOKEN_KEY, LOGIN_REFRESH_TOKEN_KEY } = consts;

  const logout = () => {
    // remove tokens
    localStorage.removeItem(LOGIN_TOKEN_KEY);
    localStorage.removeItem(LOGIN_REFRESH_TOKEN_KEY);

    localStorage.removeItem('REACT_APP_API_SUBSCRIPTION_URL');
    localStorage.removeItem('REACT_APP_API_URL');
    localStorage.removeItem('REACT_FS_SERVER_HOST');
    localStorage.removeItem('USER_ID');

    // localStore.removeItem('selected-tenant');
    localStore.removeItem('token');
    localStore.removeItem('user');

    window.location.href = '/';
  };

  const updatedProps = {
    ...props,
    logout
  };

  return <QuickNavigation {...updatedProps} />;
};

QuickNavigationContainer.propTypes = {
  history: PropTypes.object
};

export default QuickNavigationContainer;



// WEBPACK FOOTER //
// src/modules/layout/containers/QuickNavigation.js